import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorsModule } from '../editors/editors.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EditorsModule
  ],
})
export class PreviewEditModule {

}
